import http from "@/http/aisea/axios";

const resource = "/voyage_history";
const resourceWake = `${resource}/wake`;

export default {
  getVoyageHistory(voyageHistoryId) {
    return http.get(`${resource}/${voyageHistoryId}`);
  },

  deleteVoyageHistory(historyId) {
    return http.delete(`${resource}/${historyId}`);
  },

  getVoyageHistorySummary() {
    return http.get(`${resource}/summary`);
  },

  fetchWakeByVesselId(payload) {
    return http.get(`${resourceWake}/vessel/${payload.vesselId}/minify`, {
      params: {
        from: payload.from,
        limit: payload.limit,
        vessel_id: payload.vesselId,
      },
    });
  },

  getVoyageHistoryLocationSearch(
    endedAt,
    northEastLatitude,
    northEastLongitude,
    southWestLatitude,
    southWestLongitude,
    startedAt,
    ignoreVesselIds
  ) {
    return http.get(`${resource}/location_search`, {
      params: {
        ended_at: endedAt,
        north_east_latitude: northEastLatitude,
        north_east_longitude: northEastLongitude,
        south_west_latitude: southWestLatitude,
        south_west_longitude: southWestLongitude,
        started_at: startedAt,
        ignore_vessel_ids: ignoreVesselIds,
      },
    });
  },

  searchLocation(payload) {
    return http.get(`${resource}/location_search`, {
      params: payload,
    });
  },

  searchLocationForGeoJson(payload) {
    return http.get(`${resource}/location_search/geojson`, {
      params: payload,
    });
  },

  getLastPosition(vesselId) {
    return http.get(`${resource}/vessel/${vesselId}/last_position`);
  },
};
